import URI from 'urijs';
import { _ } from 'wgnet-awesomejs';

import BaseCaptchaField from 'registration/js/base/fields/captcha';
import mobile from 'wgnet-awesomejs/lib/mobile';

import template from 'registration/templates/dark/fields/captcha.html';

const CaptchaField = BaseCaptchaField.extend({
    template,
    isMTForm: _.extract('Settings.Registration.gameModificatorIsWot', false),
    getImageSrc({ url }) {
        // TODO: according PLATFORM-10770, but we should to have an config
        if (!this.isMTForm && mobile().useMobile) {
            return URI(url).addSearch('theme', 'dark_mobile').toString();
        }

        return BaseCaptchaField.prototype.getImageSrc.call(this, { url });
    },
    getContext(context = {}) {
        context.captchaSettings = {
            field_type: _.extract('Settings.Registration.fields.captcha.field_type', 'text'),
            max_length: _.extract('Settings.Registration.fields.captcha.max_length'),
        };
        return BaseCaptchaField.prototype.getContext.call(this, context);
    },
});

export default CaptchaField;



// WEBPACK FOOTER //
// ./registration/static_source/js/registration/dark/fields/captcha.js